import { Table } from 'antd';

import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useEffect, useState } from 'react';
import FilterColumns from './FilterColumns';
import { getMandateLinkDashboard, MandateLinkFilterPayload, mandateLinkPagedList } from 'api/nach';

let payPagedList: mandateLinkPagedList;

type Props = {
  filter: MandateLinkFilterPayload;
};

export const ReloadFilterListContext = createContext<any>(null);

const FilteredList = ({ filter }: Props) => {
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);

  filter.Username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');

  if (isAdmin != 'true') {
    filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  useEffect(() => {
    setIsLoading(false);
    // setPagedList(payPagedList);
    filter.PageNo = 1;
    filter.PageSize = 10;
    console.log('mandate link dash req', filter);
    getMandateLinkDashboard(filter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
          console.log('mandate link dashboard ', res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, [filter, isRetry]);

  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
    }
    setIsLoading(false);

    filter.Username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }

    filter.PageNo = _pagination.current;
    filter.PageSize = _pagination.pageSize;
    getMandateLinkDashboard(filter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(FilterColumns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <ReloadFilterListContext.Provider value={{ setIsRetry, isRetry }}>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        pagination={{
          pageSize: 10,
          total: pagedList.noOfRecords,
          current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
    </ReloadFilterListContext.Provider>
  );
};

export default FilteredList;
